import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "./Education.css";
import { FaGraduationCap, FaSchool } from "react-icons/fa";
import { IoCalendar } from "react-icons/io5";
import { GiOpenBook } from "react-icons/gi";
import { RiCodeSSlashFill } from "react-icons/ri";

const Education = () => {
  return (
    <section className="qualification__section">
      <br />
      <h2 className="section__title">Qualification</h2>
      <span className="section__subtitle">My Education Journey</span>

      <VerticalTimeline>
        <VerticalTimelineElement
          className="vertical-timeline-element--work qualification__cart"
          // contentStyle={{ background: "green", color: "#fff" }}
          // iconStyle={{ background: "green", color: "#fff" }}
          icon={<RiCodeSSlashFill />}
        >
          <h3 className="vertical-timeline-element-title qualification__title">
            MERN STACK COURSE
          </h3>
          <h4 className="vertical-timeline-element-subtitle qualification__subtitle">
            3RI Technology Pune{" "}
          </h4>
          <p>
            <span className="qualification__subtitle"> Duration - 6 Month</span>
            <div className="qualification__calender">
              <i>
                <IoCalendar />
              </i>
              {""} Aug 2022 - Jan 2023
            </div>
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work qualification__cart"
          // iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
          icon={<FaGraduationCap />}
        >
          <h3 className="vertical-timeline-element-title qualification__title">
            Bachelor Of Computer Application
          </h3>
          <h4 className="vertical-timeline-element-subtitle qualification__subtitle">
            Pune University
          </h4>
          <p>
            <span className="qualification__subtitle">8.52 CGPA</span>
            <div className="qualification__calender">
              <i>
                <IoCalendar />
              </i>
              {""} 2019 - 2022
            </div>
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work qualification__cart"
          // iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
          icon={<FaSchool />}
        >
          <h3 className="vertical-timeline-element-title qualification__title">
            HSC - Science
          </h3>
          <h4 className="vertical-timeline-element-subtitle qualification__subtitle">
            Maharashtra - State Borad
          </h4>
          <p>
            <span className="qualification__subtitle">61.52%</span>
            <div className="qualification__calender">
              <i>
                <IoCalendar />
              </i>
              {""} 2016 - 2018
            </div>
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          // iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
          icon={<GiOpenBook />}
        >
          <h3 className="vertical-timeline-element-title qualification__title">
            SSC
          </h3>
          <h4 className="vertical-timeline-element-subtitle qualification__subtitle ">
            Maharashtra - State Borad
          </h4>
          <p>
            <span className="qualification__subtitle">78.20%</span>
            <div className="qualification__calender">
              <i>
                <IoCalendar />
              </i>
              {""} March 2016
            </div>
          </p>
        </VerticalTimelineElement>
      </VerticalTimeline>
    </section>
  );
};

export default Education;
